<app-data-grid-comp
    *ngIf="!error"
    [tableId]="db_tables.LetterFooters"
    [columns]="columns"
    [filterCategories]="filterCategories"
    [gridDataResult]="gridDataResult"
    [isLoading]="isLoading"
    [pageSize]="pageSize"
    [skip]="skip"
    category="Letters-LetterFooters"
    [rowSelectionSettings]="{
        canSelectRows: true,
        selectableMode: 'multiple',
        selectRowBy: 'id'
    }"
    clickableRows="true"
    [isLoading]="isLoading"
    [clearSelectedItems]="clearSelectedItems"
    searchable="true"
    [sortable]="{
        mode: 'multiple'
    }"
    [sortableColumns]="sortableColumns"
    [accessAndHistoryURL]="accessAndHistoryURL"
    [historyDialogSettings]="{
        showEffectiveDateColumn: false
    }"
    [showAccessIcon]="false"
    [filterToggleDetails]="filterToggleDetails"
    [rowActionButtons]="gridActionButtons"
    (rowActionEvent)="copy($event)"
    (emitToggleFilter)="updateFilterToggleDetails($event)"
    (emitPageChangeEvent)="pageChange($event)"
    (emitSearchEvent)="search($event)"
    (emitOpenDialogEvent)="updateOrCreateLetterFooter($event)"
    (emitDeleteEvent)="deleteItems($event)"
    (emitFilterEvent)="filterCallback($event)"
    (emitSortEvent)="sortChange($event)"
></app-data-grid-comp>

<!-- <app-error-card *ngIf="error"></app-error-card> -->